import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { OrderStateService } from 'libs/core/src/lib/state/order.state.service';
import { ENVIRONMENT_TOKEN } from 'libs/core/src/public-api';
import { DateTime } from 'luxon';
import { tap, timer } from 'rxjs';

@UntilDestroy()
@Component({
  template: '',
  standalone: false
})
export class SimpleCountdownComponent implements OnInit {
  @Output() orderTtlChange = new EventEmitter<number>();
  orderTtl: DateTime;
  orderTtlSeconds: number;

  accessibleValue: {
    minutes: number;
    seconds: number;
  } = null;

  constructor(@Inject(ENVIRONMENT_TOKEN) protected environment: any, protected orderStateService: OrderStateService) {}

  ngOnInit(): void {
    timer(0, 1000)
      .pipe(
        tap(() => this.setTime()),
        untilDestroyed(this)
      )
      .subscribe();

    this.orderStateService.state$.pipe(untilDestroyed(this)).subscribe((order) => {
      this.orderTtl = order?.status != 4 ? order?.dateTimeToLive : null;
      this.setTime();
    });
  }

  setTime() {
    const seconds = this.orderTtl?.toSeconds() - DateTime.now().toSeconds();
    const orderTtlSeconds = !isNaN(seconds) ? Math.round(seconds) : null;
    if (orderTtlSeconds) {
      this.setAccessibleValue(Math.round(orderTtlSeconds));
    }

    this.orderTtlSeconds = orderTtlSeconds;
    this.orderTtlChange.emit(this.orderTtlSeconds);
  }

  private setAccessibleValue(orderTtlSeconds?: number) {
    if (!orderTtlSeconds || (orderTtlSeconds % 30 !== 0 && orderTtlSeconds > 10)) {
      return;
    }

    const minutes = Math.floor(orderTtlSeconds / 60);
    const seconds = orderTtlSeconds > 10 ? orderTtlSeconds % 60 : orderTtlSeconds;
    this.accessibleValue = { minutes, seconds };
  }
}
